export default __webpack_public_path__ + "static/media/IconLink.b0bb0112.svg";